<template>
	<div
		class="w-full max-w-140 group-[.received]:me-auto group-[.received]:pe-15 group-[.sent]:ms-auto group-[.sent]:ps-15"
	>
		<div
			class="rounded-xl p-3 w-full border group-[.received]:rounded-tl-none group-[.received]:bg-white group-[.received]:border-gray-darker group-[.received]:text-primary-superdark group-[.sent]:rounded-br-none group-[.sent]:bg-primary group-[.sent]:border-primary group-[.sent]:text-white"
		>
			<div>
				<div class="bg-gray rounded-xs h-4 mb-1 w-5/6 animate-pulse"></div>
				<div class="bg-gray rounded-xs h-4 mb-1 w-4/6 animate-pulse"></div>
				<div class="bg-gray rounded-xs h-4 mb-1 w-3/6 animate-pulse"></div>
				<div class="bg-gray rounded-xs h-4 w-2/6 animate-pulse"></div>
			</div>
			<div
				class="text-end text-sm pt-2 group-[.received]:text-gray-darker group-[.sent]:text-gray-light"
			>
				<div
					class="bg-gray rounded-xs h-4 w-15 animate-pulse inline-block"
				></div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
